// Single source of truth for sidebar width so layout.tsx (AntD Layout.Sider)
// and SidebarMenu.tsx (the sidebar's own root element) can't drift apart.
export const SIDEBAR_WIDTH_EXPANDED = 260;
export const SIDEBAR_WIDTH_COLLAPSED = 88;
